import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { usePWAStore } from '../../store/pwaStore';
import { MOBILE_TABS } from '../../config/mobileTabConfig';

export const MobileTabBar: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { toggleMobileSidebar } = usePWAStore();

  const handleTabPress = (route: string | null) => {
    if (route === null) {
      toggleMobileSidebar();
    } else {
      navigate(route);
    }
  };

  const isActive = (route: string | null) => {
    if (route === null) return false;
    return location.pathname === route || location.pathname.startsWith(route + '/');
  };

  return (
    <nav className="fixed bottom-0 left-0 right-0 z-40 bg-white dark:bg-gray-800 border-t border-gray-200 dark:border-gray-700 safe-area-inset">
      <div className="flex items-center justify-around h-14">
        {MOBILE_TABS.map((tab) => {
          const active = isActive(tab.route);
          return (
            <button
              key={tab.id}
              onClick={() => handleTabPress(tab.route)}
              className={`flex flex-col items-center justify-center flex-1 h-full pt-1 pb-1 transition-colors ${
                active
                  ? 'text-green-600 dark:text-green-400'
                  : 'text-gray-500 dark:text-gray-400'
              }`}
            >
              <tab.icon className={`h-6 w-6 ${active ? 'stroke-2' : ''}`} />
              <span className="text-[10px] mt-0.5 leading-tight">{tab.label}</span>
            </button>
          );
        })}
      </div>
      {/* Extra padding for safe area on notched devices */}
      <div className="safe-area-inset-bottom" />
    </nav>
  );
};
